import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';
import { generatePath, useNavigate } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import { useSelector } from 'hooks/useSelector';
import { getCustomName } from 'modules/users/selectors/currentUser';
import { Card, Button } from 'ui/base';
import { b } from 'utils/i18nUtils';

import { cardStyle } from './UI';

const CheckMail = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const customName = useSelector(getCustomName);

  const handleOnClick = React.useCallback(() => {
    const path = generatePath(PATH.FORGOT_PASSWORD.path);
    navigate(path);
  }, [navigate]);

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {intl.formatMessage(
            {
              id: 'app_tab.forgot_password',
              defaultMessage: '{name} · Forgot password',
            },
            { name: customName }
          )}
        </title>
      </Helmet>

      <Card variant="borderless" className={cardStyle}>
        <div className="content text-secondary d-flex flex-column align-items-center gap-3 text-center">
          <div className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center d-inline-block h-16 w-16">
            <span className="fb-icon--mail text-4xl lh-1" />
          </div>

          <div className="text-base font-weight-bold">
            <FormattedMessage id="page.forgotPassword.checkMail.title" defaultMessage="Check your mail" />
          </div>

          <FormattedMessage
            id="page.forgotPassword.checkMail.describe"
            defaultMessage="If a user account is linked to the entered username, <strong>you will receive a password reset email to the email</strong> address linked to this account."
            values={{ strong: b }}
          />

          <FormattedMessage
            id="page.forgotPassword.checkMail.help"
            defaultMessage="Make sure to <strong>check your spam folder.</strong>"
            values={{ strong: b }}
          />
        </div>

        <div className="border-top mt-4 p-4 text-right">
          <Button onClick={handleOnClick} data-cy="back-button">
            <FormattedMessage id="back" defaultMessage="Back" />
          </Button>
        </div>
      </Card>
    </React.Fragment>
  );
};

export default CheckMail;
